import { makeStyles } from "@material-ui/core/styles"
import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	row: {
		gap: "12px",
		padding: "10px 14px",
		borderRadius: 8,
		border: `1.5px solid ${colors.gray[100]}`,
		backgroundColor: colors.gray[0],
		cursor: "pointer",
		userSelect: "none"
	},
	rowSelected: {
		border: `1.5px solid ${colors.purple[500]}`,
		backgroundColor: colors.purple[50]
	},
	bullet: {
		width: 18,
		height: 18,
		borderRadius: "50%",
		border: "2px solid #bdbdbd",
		flexShrink: 0
	},
	bulletSelected: {
		border: `2px solid ${colors.purple[500]}`
	},
	bulletInner: {
		width: 10,
		height: 10,
		borderRadius: "50%",
		backgroundColor: colors.purple[500]
	},
	bulletSquare: {
		borderRadius: 999
	},
	bulletInnerSquare: {
		borderRadius: 999
	},
	rowDisabled: {
		opacity: 0.4,
		cursor: "default",
		pointerEvents: "none"
	},
	label: {
		fontSize: 14,
		color: colors.gray[800]
	},
	labelSelected: {
		color: colors.purple[500]
	}
})

export default useStyles
